import { render, staticRenderFns } from "./AcceptedTabContentCompnent.vue?vue&type=template&id=304912ea&scoped=true&"
import script from "./AcceptedTabContentCompnent.vue?vue&type=script&lang=js&"
export * from "./AcceptedTabContentCompnent.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedTabContentCompnent.vue?vue&type=style&index=0&id=304912ea&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304912ea",
  null
  
)

export default component.exports